import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconActivityQuadTourComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth={1.7}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1284_828)">
          <path
            d="M17.5233 7.56889H23.2969V5.41832L13.3776 2.94707L12.4414 5.40158L17.5233 7.56889ZM17.5233 7.56889L12.9216 8.49796C11.7684 8.73116 11.0363
            9.87191 11.3044 11.0174L12.005 14.0053C12.1574 14.6557 12.6124 15.1939 13.2289 15.4524L15.6547 16.4689C16.3768 16.7719 17.2126 16.5253 17.6547
            15.8791L18.6272 14.4588L19.2662 15.0978C19.8076 15.6392 20.0299 16.422 19.854 17.1671L19.0058 20.7013C18.765 21.7216 17.673 22.2879 16.7004 21.8975L1.75687
            16.7143V13.6558L0.703125 9.77488C1.16667 5.393 4.87425 1.97839 9.37894 1.97839C10.8203 1.97839 12.1799 2.32775 13.3776 2.94711"
            fill="none"
          />
          <path d="M15.4249 16.5163L14.3395 20.937" fill="none" />
          <path
            d="M0.703125 9.7749L6.42563 11.771L7.47937 15.6177L1.75687 13.6557"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
        </g>
        <defs>
          <clipPath id="clip0_1284_828">
            <rect fill="none" height="24" width="24" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

IconActivityQuadTourComponent.displayName = 'IconActivityQuadTour';

const IconActivityQuadTour = React.memo(IconActivityQuadTourComponent);

export default IconActivityQuadTour;
